export default {
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'tag/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/Tag.js